export default "__VITE_ASSET__D4WVZe4C__"